(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('e-invoice-upload-view', {
            parent: 'entity',
            params:{screen: 'eInvoiceUpload'},
            url: '/e-invoice-upload',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.eInvoiceUpload.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/e-invoice-upload/e-invoice-upload.html',
                    controller: 'EInvoiceUploadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   
                    $translatePartialLoader.addPart('eInvoiceUpload');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                chargeTypes: ['StaticLookUp', function(StaticLookUp){
                    return StaticLookUp.getChargesType().$promise;
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }],
                previousSystemSettings:['TransactionChargesSummaryView',function(TransactionChargesSummaryView){
                	return TransactionChargesSummaryView.getPreviousBusinessDate().$promise;
                }],
                configSetting :['GlobalValues', function(GlobalValues) {
                    return GlobalValues.getConfigSettings();
                }],
                financialYears: ['StaticLookUp', function(StaticLookUp){
					return StaticLookUp.getPastAndPresentFinancialYears().$promise;
				}]
               
            }
        })
      
         };
    })();
